/* storage key */
export const LANG_KEY = 'lang';
export const TABLE_KEY = 'table';
export const ADJUST_KEY = 'adjust';
export const CONTEXT_KEY = 'context';
export const BACK_TOP_KEY = 'backTop';
export const CHANNEL_STORAGE_KEY = 'channel';
